import type {SocialPostDesignActionPanelProps} from '@Components/panels/social-post-design-action-panel';

export type SocialPostsDesignActionModalProps = SocialPostDesignActionPanelProps;

export const PANEL_ID = 'social-post-design-action-panel';
export const SOCIAL_POST_DESIGN_ACTION_MODAL_WIDTH_PX = 919;
export const SOCIAL_POST_DESIGN_ACTION_MODAL_BORDER_RADIUS_PX = 16;
export const SOCIAL_POST_DESIGN_ACTION_MODAL_HEIGHT = 'fit-content';
export const SOCIAL_POST_DESIGN_ACTION_MODAL_MIN_HEIGHT = '305px';
